import {
  type IGamificationDiscount,
  type IGamificationInfo,
  type TGamificationDiscountType,
} from '@/templates/WebCheckoutMercadoPago/@interfaces';

const BUNDLE_DISCOUNT_TYPE: Record<string, TGamificationDiscountType> = {
  prata: 'small',
  ouro: 'medium',
  diamante: 'large',
};

export function getGamificationDiscount(
  bundleNameId: string | null | undefined,
  gamificationInfo: IGamificationInfo | null | undefined
): IGamificationDiscount | null {
  if (!gamificationInfo?.eligible || gamificationInfo.cycle_ended) {
    return null;
  }

  const type = bundleNameId ? BUNDLE_DISCOUNT_TYPE[bundleNameId] : null;

  if (!type) return null;

  return gamificationInfo.descontos?.find((d) => d.type === type) || null;
}

export function isGamificationCouponLocked(
  gamificationInfo: IGamificationInfo | null | undefined,
  bundleNameId: string | null | undefined
): boolean {
  return getGamificationDiscount(bundleNameId, gamificationInfo) !== null;
}

export function parsePriceBRL(price: string | number): number {
  if (typeof price === 'number') return price;

  const parsed = price
    .replace(/R\$\s*/i, '')
    .replace(/\./g, '')
    .replace(',', '.');

  return Number(parsed) || 0;
}

export function formatPriceBRL(value: number): string {
  const [intPart, decPart] = value.toFixed(2).split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `R$ ${formattedInt},${decPart}`;
}
